// Static data: pricing, reviews, media
export const MEDIA = {
  hero: "/photos/hero.webp",
  wave: "https://static.prod-images.emergentagent.com/jobs/8dd262a5-3358-4fec-b560-9ec1a6767c50/images/bb3d9d54ab87220c048378d8f9d417fef655c4bbcc05be466eeb4af8e42f1235.png",
  motor: "/boats/motor.webp",
  electricRoof: "/boats/electricRoof.webp",
  electric: "/boats/electric.webp",
  pedal: "/boats/pedal.webp",
  pedalSlide: "/boats/pedalSlide.webp",
  landscape: "/photos/palava-jinak.webp",
};

export const FLEET = [
  {
    key: "motor",
    price: 590,
    priceEur: 27,
    capacity: 4,
    image: MEDIA.motor,
    accent: "from-amber-300 to-yellow-400",
    swim: false,
    swimType: "boat",
    showTag: true,
  },
  {
    key: "electricRoof",
    price: 380,
    priceEur: 17,
    capacity: 4,
    image: MEDIA.electricRoof,
    accent: "from-sky-300 to-cyan-400",
    swim: false,
    swimType: "boat",
    showTag: false,
  },
  {
    key: "electric",
    price: 380,
    priceEur: 17,
    capacity: 4,
    image: MEDIA.electric,
    accent: "from-sky-200 to-blue-300",
    swim: true,
    swimType: "boat",
    showTag: false,
  },
  {
    key: "pedal",
    price: 280,
    priceEur: 13,
    capacity: 4,
    image: MEDIA.pedal,
    accent: "from-yellow-200 to-amber-300",
    swim: true,
    swimType: "pedal",
    showTag: false,
  },
  {
    key: "pedalSlide",
    price: 300,
    priceEur: 14,
    capacity: 5,
    image: MEDIA.pedalSlide,
    accent: "from-cyan-200 to-sky-300",
    swim: true,
    swimType: "pedal",
    showTag: false,
  },
];

// Real Google reviews (selected) — overall 4.1/5 from 21 reviews.
// Source: https://www.google.com/search?kgmid=%2Fg%2F11cpq8s9sg
export const REVIEWS_AVG = 4.1;
export const REVIEWS_COUNT = 21;

export const REVIEWS = [
  {
    name: "Jakub Lojek",
    rating: 4,
    date: {
      cz: "před 5 lety",
      en: "5 years ago",
      de: "vor 5 Jahren",
    },
    initials: "JL",
    text: {
      cz: "Půjčovna paráda, včetně možnosti rezervace.",
      en: "Great rental, including the option to book in advance.",
      de: "Tolle Vermietung, inklusive Reservierungsmöglichkeit.",
    },
  },
  {
    name: "Mirek K.",
    rating: 5,
    date: {
      cz: "před 2 lety",
      en: "2 years ago",
      de: "vor 2 Jahren",
    },
    initials: "MK",
    text: {
      cz: "Parádní výlet na motorovém člunu, majitel velice ochotný a příjemný. Doporučuji.",
      en: "Awesome trip on the motorboat, the owner was very friendly and helpful. Recommended.",
      de: "Toller Ausflug mit dem Motorboot, der Inhaber sehr freundlich und hilfsbereit. Empfehlenswert.",
    },
  },
  {
    name: "Tereza Zachová",
    rating: 5,
    date: {
      cz: "před 8 lety",
      en: "8 years ago",
      de: "vor 8 Jahren",
    },
    initials: "TZ",
    text: {
      cz: "Velmi milý a ochotný pán, který vám půjčí klasická šlapadla se skluzavkou i bez, i motorové čluny. Plus krásný výhled na Pálavské vrchy je z vody.",
      en: "Very kind and helpful gentleman — pedal boats with or without a slide, as well as motorboats. Plus a beautiful view of the Pálava hills from the water.",
      de: "Sehr netter und hilfsbereiter Herr — Tretboote mit oder ohne Rutsche, sowie Motorboote. Dazu ein wunderschöner Blick auf die Pálava-Hügel vom Wasser.",
    },
  },
  {
    name: "Petr Vazovský",
    rating: 5,
    date: {
      cz: "před 8 lety",
      en: "8 years ago",
      de: "vor 8 Jahren",
    },
    initials: "PV",
    text: {
      cz: "Při letním cestování jsme se zajeli podívat i sem. Ke šlapadlům jsme dorazili těsně před setměním, ale i tak se k nám personál choval vstřícně. Ceny jsou přijatelné. Místo mohu při západu slunce jen doporučit.",
      en: "We stopped by during a summer trip. We arrived at the pedal boats just before sunset, yet the staff was very welcoming. Prices are fair. I can only recommend the place at sunset.",
      de: "Auf einer Sommerreise haben wir einen Abstecher gemacht. Wir kamen kurz vor Sonnenuntergang an, aber das Personal war trotzdem sehr freundlich. Faire Preise. Bei Sonnenuntergang nur zu empfehlen.",
    },
  },
  {
    name: "Jaroslav Červenka",
    rating: 5,
    date: {
      cz: "před 8 lety",
      en: "8 years ago",
      de: "vor 8 Jahren",
    },
    initials: "JČ",
    text: {
      cz: "Po zapůjčení lodičky s elektrickým pohonem si můžete vychutnat překrásnou projížďku po horním Mušovském jezeře od Aqualandu Moravia k Pasohlávkám.",
      en: "After renting an electric boat you can enjoy a beautiful ride across the upper Mušov lake from Aqualand Moravia to Pasohlávky.",
      de: "Nach dem Mieten eines Elektroboots können Sie eine wunderschöne Fahrt über den oberen Mušov-See von Aqualand Moravia nach Pasohlávky genießen.",
    },
  },
  {
    name: "Erik",
    rating: 5,
    date: {
      cz: "před 8 lety",
      en: "8 years ago",
      de: "vor 8 Jahren",
    },
    initials: "E",
    text: {
      cz: "Ochotný a milý personál. Možnost rezervace předem. Vše bez problémů. Takhle to má vypadat!",
      en: "Helpful and friendly staff. Reservations possible in advance. Everything ran smoothly. This is how it should be!",
      de: "Hilfsbereites und freundliches Personal. Vorab-Reservierung möglich. Alles lief reibungslos. So muss das sein!",
    },
  },
];

export const PHONE = "+420 724 909 002";
export const PHONE_RAW = "+420724909002";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/P%C5%AFj%C4%8Dovna+motorov%C3%BDch+%C4%8Dlun%C5%AF+a+%C5%A1lapadel/@48.9009417,16.5764881,185m/data=!3m1!1e3!4m6!3m5!1s0x4712c96289777011:0xcae1e24bf5a65389!8m2!3d48.9009781!4d16.5762623!16s%2Fg%2F11cpq8s9sg";
// Public place embed using the actual coordinates of the rental dock
export const MAPS_EMBED_URL =
  "https://maps.google.com/maps?q=P%C5%AFj%C4%8Dovna+motorov%C3%BDch+%C4%8Dlun%C5%AF+a+%C5%A1lapadel&ll=48.9009781,16.5762623&z=16&output=embed";
export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=48.9009781,16.5762623&destination_place_id=ChIJEXB3iWLJEkcRiVOm9UvioMo";
